module.exports = __webpack_public_path__ + "assets/img/fuzhu.351fabad.png";